import React, { FunctionComponent, useState, useEffect } from 'react';
import { Card, Text, ScreenReaderText } from '@mlc/web-ui-toolkit';
import LoadingIndicator from '../../../../../common/LoadingIndicator';
import {
	asFormattedDate,
	asCurrency,
	asTodaysDate,
} from '../../../../../common/formatter';
import { PlanInvestments as PlanInvestmentsDomain } from '../../../../../../logic/domains/planProfile.domain';
import { getPlanInvestments } from '../../../../../../logic/functions/planProfile.function';
import ApiError from '../../../../Error/ApiError';
import Funds from './Funds';
import Percentage from './Percentage';
import DefaultOption from './DefaultOption';
import Tab from '../../Common/Tab';
import planProfileTestIds from '../../PlanProfile.elements';

type Props = {
	planUUID: string;
	date: string;
	investors: number;
};

const PlanInvestments: FunctionComponent<Props> = ({
	date,
	investors,
	planUUID,
}) => {
	const [planInvestments, setPlanInvestments] = useState<
		PlanInvestmentsDomain | undefined
	>();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			const planInvestments = await getPlanInvestments(planUUID);
			setPlanInvestments(planInvestments);
			setIsLoading(false);
		};
		fetchData();
	}, []);

	if (isLoading) {
		return <LoadingIndicator />;
	}

	if (!planInvestments) {
		return <ApiError />;
	}

	return (
		<Tab title="Plan Investments">
			<Text
				fontWeight="semibold"
				data-id={planProfileTestIds.planInvestmentBalAsAtDate}
				el="h5"
				marginTop={0}
				marginBottom={4}
			>
				Investment balance (as at{' '}
				{investors > 0 ? asFormattedDate(date) : asTodaysDate()})
			</Text>
			<Text
				fontSize="tiny"
				fontWeight="semibold"
				color="mlcOrange"
				margin={0}
				data-id={planProfileTestIds.planInvestmentBalance}
				el="p"
			>
				{asCurrency(
					investors > 0 && planInvestments.totalFundsAmount
						? planInvestments.totalFundsAmount
						: 0
				)}
			</Text>
			<Percentage
				activeChoice={
					investors > 0 && planInvestments.investmentChoice.activeChoice
						? planInvestments.investmentChoice.activeChoice
						: 0
				}
				defaultOption={
					investors > 0 && planInvestments.investmentChoice.defaultOption
						? planInvestments.investmentChoice.defaultOption
						: 0
				}
			/>
			<DefaultOption
				strategy={planInvestments.investmentStrategy}
				display={investors > 0}
			/>
			<Funds
				date={investors > 0 ? asFormattedDate(date) : asTodaysDate()}
				planInvestments={planInvestments}
			/>
		</Tab>
	);
};

export default PlanInvestments;
